export default __webpack_public_path__ + "static/media/chevron-right-hover.93f6dbf8.svg";